import { PLACEHOLDER_IMG } from "@/lib/api";
import { WatermarkOverlay, noSave, productAlt } from "@/components/WatermarkOverlay";

export const ProductGallery = ({ name, activeImg, gallery, onSelect }) => {
  const alt = productAlt({ name });
  return (
    <div className="gh-fade-up">
      <div className="relative rounded-2xl overflow-hidden border border-[#E5DFD5] bg-[#F2EFEB]">
        <img src={activeImg || PLACEHOLDER_IMG} alt={alt} data-testid="product-main-image" {...noSave} className="w-full h-[560px] object-cover" />
        <WatermarkOverlay />
      </div>
      {gallery.length > 1 && (
        <div className="flex gap-3 mt-4" data-testid="product-thumbnails">
          {gallery.map((img, idx) => (
            <button key={img} onClick={() => onSelect(img)} data-testid={`product-thumb-${idx}`}
              className={`relative h-20 w-20 rounded-lg overflow-hidden border-2 transition-colors ${activeImg === img ? "border-[#8E9A86]" : "border-[#E5DFD5] hover:border-[#D1CCC5]"}`}>
              <img src={img} alt={`${alt} — view ${idx + 1}`} {...noSave} className="h-full w-full object-cover" />
              <WatermarkOverlay />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
